import { useState, useEffect } from "react";
import axios from "axios";
import {
  BadgeDelta,
  Card,
  Grid,
  Flex,
  Metric,
  ProgressBar,
  Text,
} from "@tremor/react";
import { getDateGranularity } from "../../helpers";
import { withToast } from "../../contexts/toastr.context";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { MixpanelService } from "../../_service/mixpanel.service";
const base = process.env.REACT_APP_BASE_URL;

const KpiCardComponent = ({ dateRange, event, title, user }) => {
  const [metric, setMetric] = useState(0);
  useEffect(() => {
    const fetchData = async () => {
      const fromDate = dateRange[0].toISOString().split("T")[0];
      const toDate = dateRange[1].toISOString().split("T")[0];

      try {
        const data = await MixpanelService.getKpiData(user, {
          event,
          from_date: fromDate,
          to_date: toDate,
          granularity: getDateGranularity(fromDate, toDate),
        });
        setMetric(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [dateRange, event]);

  return (
    <Card>
      <div className="truncate">
        <Text>{title}</Text>
        <Metric className="truncate">{metric}</Metric>
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth,
});

const KpiCard = withToast(
  withRouter(connect(mapStateToProps)(KpiCardComponent))
);

export default KpiCard;
